import DeleteCategoryUnable from './DeleteCategoryUnable';

export default DeleteCategoryUnable;
